import { useRef, useEffect, useState, useCallback } from 'react';
import amplitude from '../services/amplitude';

const PARKING_TICKET_EXPIRE_TIMEOUT = 170 * 1000;

export const useTicketAuthExpiredDialogDisclosure = () => {
  const timeoutRef = useRef<NodeJS.Timeout>(null);
  const [isTicketAuthExpiredDialogOpen, setIsTicketAuthExpiredDialogOpen] =
    useState<boolean>(false);

  useEffect(() => {
    if (isTicketAuthExpiredDialogOpen) return;

    const timeout = setTimeout(() => {
      amplitude.paymentTicketExpireDialogPageView();
      setIsTicketAuthExpiredDialogOpen(true);
    }, PARKING_TICKET_EXPIRE_TIMEOUT);

    timeoutRef.current = timeout;

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [isTicketAuthExpiredDialogOpen]);

  return {
    isTicketAuthExpiredDialogOpen,
    onTicketAuthExpiredDialogClose: useCallback(
      () => setIsTicketAuthExpiredDialogOpen(false),
      [],
    ),
    onTicketAuthExpiredDialogOpen: useCallback(
      () => setIsTicketAuthExpiredDialogOpen(true),
      [],
    ),
  };
};
